import { render } from "./HeroFooter.vue?vue&type=template&id=980db7a0"
import script from "./HeroFooter.vue?vue&type=script&lang=js"
export * from "./HeroFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__